import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import '../App.css';
import { useAuth } from '../context/AuthContext';
import { RecruitmentCountsProvider } from '../context/RecruitmentCountsContext';

const sectionMetadata = {
  'career-banner': {
    title: 'Careers Banner | HPPL Careers Admin',
    description: 'Manage responsive banner images on the careers page.',
  },
  overview: {
    title: 'Overview | HPPL Careers Admin',
    description: 'View HPPL recruitment activity, open jobs, applications, shortlisted candidates, and accepted offers.',
  },
  'job-openings': {
    title: 'Job Openings | HPPL Careers Admin',
    description: 'View and manage job openings across HPPL.',
  },
  'add-job': {
    title: 'Add New Job | HPPL Careers Admin',
    description: 'Create or update a job opening for HPPL careers.',
  },
  'bulk-upload': {
    title: 'Bulk Upload Jobs | HPPL Careers Admin',
    description: 'Upload and create multiple HPPL job openings in bulk.',
  },
  applications: {
    title: 'Applications | HPPL Careers Admin',
    description: 'Review and manage candidate applications for HPPL job openings.',
  },
  master: {
    title: 'Master | HPPL Careers Admin',
    description: 'Manage recruitment master data used throughout the HPPL careers portal.',
  },
  'mail-ids': {
    title: 'Mail IDs | HPPL Careers Admin',
    description: 'Manage company application notification recipients by state and city.',
  },
  culture: {
    title: 'Culture Content | HPPL Careers Admin',
    description: 'Manage the culture content displayed on the HPPL careers website.',
  },
  'add-culture': {
    title: 'Add Culture Content | HPPL Careers Admin',
    description: 'Create or update culture content for the HPPL careers website.',
  },
  'opening-bin': {
    title: 'Job Openings Bin | HPPL Careers Admin',
    description: 'Restore or permanently remove deleted HPPL job openings.',
  },
  'application-bin': {
    title: 'Job Applications Bin | HPPL Careers Admin',
    description: 'Restore or permanently remove deleted HPPL job applications.',
  },
};

function setMetaContent(selector, content) {
  document.querySelector(selector)?.setAttribute('content', content);
}

function Dashboard({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [active, setActive] = useState('overview');
  const { user, logout } = useAuth();

  useEffect(() => {
    const metadata = sectionMetadata[active] || sectionMetadata.overview;
    document.title = metadata.title;
    setMetaContent('meta[name="description"]', metadata.description);
    setMetaContent('meta[property="og:title"]', metadata.title);
    setMetaContent('meta[property="og:description"]', metadata.description);
  }, [active]);

  const handleNavigate = (section) => {
    setActive(section);
    if (window.matchMedia('(max-width: 720px)').matches) {
      setCollapsed(true);
    }
  };

  return (
    <RecruitmentCountsProvider>
      <div className="layout-root">
        <Header onToggleSidebar={() => setCollapsed(c => !c)} user={user} onLogout={logout} />
        <div className="layout-body">
          <Sidebar collapsed={collapsed} active={active} onSelect={handleNavigate} />
          <main className="main-content">
            {React.isValidElement(children) ? React.cloneElement(children, { activeSection: active, onNavigate: handleNavigate }) : children}
          </main>
        </div>
      </div>
    </RecruitmentCountsProvider>
  );
}

export default Dashboard;
